import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "pl-4" }
const _hoisted_4 = { class: "d-flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_menu, {
      "close-on-content-click": false,
      elevation: "1"
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$label_outline" }, props, {
          class: "mr-3",
          disabled: _ctx.disableActivator
        }), null, 16, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          width: "300px",
          elevation: "2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "pa-2 d-flex justify-center disabled"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.search,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                      outlined: "",
                      "hide-details": "",
                      label: "Rechercher",
                      "persistent-hint": true,
                      density: "compact",
                      "append-inner-icon": "$fa-search",
                      clearable: "",
                      "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = ''))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "px-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_virtual_scroll, {
                      bench: "5",
                      items: _ctx.filteredAllCompanyWithPrimaryLogTags,
                      height: "300",
                      class: "pb-0",
                      style: {"overflow-x":"hidden"}
                    }, {
                      default: _withCtx(({ item: tag }) => [
                        (!tag.header)
                          ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: _ctx.selectedTags,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTags) = $event)),
                                      "hide-details": "",
                                      density: "compact",
                                      ripple: false,
                                      indeterminate: _ctx.isIndeterminate(tag.id),
                                      class: "mt-0 pt-0",
                                      onChange: ($event: any) => (_ctx.statusChange(tag.id)),
                                      value: tag.id
                                    }, null, 8, ["modelValue", "indeterminate", "onChange", "value"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, {
                                  cols: "9",
                                  class: "d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_chip, {
                                      label: "",
                                      color: tag.color,
                                      variant: "flat",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.getTagNameToSelect(tag)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock(_component_v_row, {
                              key: 1,
                              class: "mt-2 mb-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "1" }),
                                _createVNode(_component_v_col, { cols: "9" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tag.header), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                      ]),
                      _: 1
                    }, 8, ["items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "py-1"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isAccountingLine)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          _createVNode(_component_v_btn, {
                            onClick: _ctx.updateTags,
                            size: "small",
                            variant: "text"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" Appliquer ")
                            ])),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_v_checkbox, {
                              label: "Appliquer les tags au justificatif ?",
                              modelValue: _ctx.isApplyUpward,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isApplyUpward) = $event)),
                              class: "small-label",
                              dense: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_v_btn, {
                              onClick: _ctx.updateTags,
                              size: "small",
                              variant: "text"
                            }, {
                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createTextVNode(" Appliquer ")
                              ])),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snackbars, (sb, index) => {
      return (_openBlock(), _createBlock(_component_v_snackbar, {
        key: index,
        "onUpdate:modelValue": ($event: any) => (_ctx.deleteSnackbar(index)),
        timeout: 15000,
        style: _normalizeStyle('margin-top: ' + (_ctx.getNumberOfDisplayedSnackBar(index) + 1) * 56 + 'px'),
        "model-value": sb.display,
        location: "end"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _withModifiers(($event: any) => (_ctx.createSuggestion(sb)), ["stop"]),
            variant: "text"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode(" Appliquer ")
            ])),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_v_btn_icon, {
            icon: "$oss-close",
            size: "small",
            onClick: _withModifiers(($event: any) => (sb.display = false), ["stop"])
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("strong", null, _toDisplayString(_ctx.getSnackbarText(sb)), 1)
        ]),
        _: 2
      }, 1032, ["onUpdate:modelValue", "style", "model-value"]))
    }), 128))
  ]))
}